// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__h3H4A","modify":"styles_modify__jfZ3f","button":"styles_button__eN2zj"};